/**
 * @desc 用户登录
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** password */
  password: string;
  /** userName */
  userName: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.UserModelResponse>> {
  return defHttp.get({
    url: '/web/user/login',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.UserModelResponse>> {
  return defHttp.get({
    url: '/mock/web/user/login',

    params,
  });
}
